var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegenerationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "change",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.986,
    height: 25.986,
    viewBox: "0 0 25.986 25.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_46",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 46",
    d: "M0,0H25.986V25.986H0Z",
    fill: "rgba(255,255,255,0.01)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_234",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 234",
    transform: "translate(2.165 2.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_47",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 47",
    d: "M18,19.076H28.827V5",
    transform: "translate(-10.421 -5)",
    fill: "none",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_48",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 48",
    d: "M20.827,21H10V32.91",
    transform: "translate(-6.752 -12.338)",
    fill: "none",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_49",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 49",
    d: "M38.5,8.248,35.248,5,32,8.248",
    transform: "translate(-16.842 -5)",
    fill: "none",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_50",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 50",
    d: "M10.5,37,7.248,40.248,4,37",
    transform: "translate(-4 -19.676)",
    fill: "none",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerationicon);
export default __webpack_public_path__ + "static/media/regeneration.icon.135916e9c5b633165c97bc47e162037b.svg";
export { ForwardRef as ReactComponent };